import mapKV from './mapKV';
import swapKV from './swapKV';
import isObject from './isObject';
import deepMerge from './deepMerge';
import buildObject from './buildObject';

export default {
  mapKV,
  swapKV,
  isObject,
  deepMerge,
  buildObject,
};



// WEBPACK FOOTER //
// ./app/utils/object/index.js